
import { DatePipe, JsonPipe } from '@angular/common'
import {CreateTicketFormFields} from '../tickets/createTicketFormFields'
import {TicketsService,EquipmentService, ServicerequestService,UserService,MessageService} from '../../services/'
import { Injectable } from '@angular/core';
import { Observable,forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { AccessUserInfo, UserDetail } from '../user/UserInfo';
@Injectable({
    providedIn: 'root'
  })
export class BartTicket
{
    datePiepe=new DatePipe('en-US')
    public userid: number;
    private formFields:CreateTicketFormFields;
    constructor(private _ticketService :TicketsService,private _equipmentService :EquipmentService, private _servicerequestService:ServicerequestService, private _userService:UserService, private router:Router,private _messageService:MessageService)
    {

        let userInfo:UserDetail = AccessUserInfo.getUserInfo();
        this._ticketService.getTicketGlobalData().subscribe((Result: any) => {   
            this.formFields=Result; //Get Latest Update value from here
            this.userid = userInfo.userId;
           }, 
           (error) => {
             // handle error here
            }
        );
    }
    public  enableColumns()
    {
        this.formFields.alertBox="";
        this.formFields.isAlertBoxInactive=true;
        this.getEquipmentAlerts();
        //getSQACodes(); already binded from ticket-info component
        //getQuestions(); already binded from ticket-info component
        //BLEED THROUGH SELECT BOXES (WORK AROUND FOR IE6)
        
        // $('#payrollCodeId').show();//Below show and hide not required here-BART-2020
        // $('#sqaCode').show();
        // $('#hoursWorkedSel').show();
        // $('#minutesWorkedSel').show();
        // $('#hoursTravelSel').show();
        // $('#minutesTravelSel').show();
        
        //SHOW IF THE THE TICKET IS NOT CLOSED
        //if(TICKETDATA == undefined || TICKETDATA.ticketstatusid[0] != 1){
        if(this.formFields.ticketStatusId == null || this.formFields.ticketStatusId != 1){
            // if($('#column2').is(':visible') == false){
            //     $('#column2').show('slide',{direction:"left"});
            // }
            // if($('#column3').is(':visible') == false){
            //     $('#column3').show('slide',{direction:"right"});
            // }
            if(this.formFields.isShowColumn2 == false){
                this.formFields.isShowColumn2=true
            }
            if(this.formFields.isShowColumn3 == false){
                this.formFields.isShowColumn3=true
            }
        }
    }

    public async getEquipmentAlerts(){
        
        var equipmentId = this.formFields.SelectedEquipmentID;
        var dateServicePerformed =this.datePiepe.transform(this.formFields.srCompletedDate,"MM/dd/yy"); //$.datepicker.parseDate('mm/dd/yy',$('#dateServicePerformed').val());
        var dateServiceProvided = this.datePiepe.transform(this.formFields.srCompletedDate,"yy-MM-dd"); //$.datepicker.formatDate('yy-mm-dd',dateServicePerformed);
        var alertData = "";
        var i = 0;
        var alertHTML = ""; var hasNickNameAlert = false; var hasEquipmentAlert = false; var hasIpAddressAlert = false;
        if(dateServiceProvided){
            //var eqObj = new Equipment();
            // var alertData = eqObj.getAlerts(alertParams);
            // var nickNameAlert = eqObj.getNickNameAlerts(equipmentId);
            // var ipAddressAlert = eqObj.getIpAddressAlerts(equipmentId);
            let alertData:any = null;
            let nickNameAlert:any = null;
            let ipAddressAlert:any = null
            var getEquipAlertParams = {
                "GETEQUIPMENTALERTS":{
                    equipmentId:equipmentId ,
                    dateServiceProvided:dateServicePerformed
                }
             }
            let getNickNameAlertsParms=
            {
                "GETMACHINENICKNAME":{
                    equipmentId:equipmentId ,
                }
             }
            let getMachineIPAddressParms=
            {
                "GETMACHINEIPADDRESS":{
                    equipmentId:equipmentId ,
                }
            }
            forkJoin(
                this._equipmentService.getEquipmentAlerts(JSON.stringify(getEquipAlertParams)),
                this._equipmentService.getMachineNickName(JSON.stringify(getNickNameAlertsParms)),
                this._equipmentService.getMachineIPAddress(JSON.stringify(getMachineIPAddressParms))
            ).subscribe(
              data => 
              {
                  
                alertData=data[0]
                nickNameAlert=data[1]
                ipAddressAlert=data[2]
                try{
             
                    if (alertData.alerts && alertData.alerts[0].EquipmentAlert && alertData.alerts[0].EquipmentAlert.length) {
                         for(i=0;i<alertData.alerts.length;i++){
                             alertHTML += '<div>';
                             alertHTML += alertData.alerts[i].EquipmentAlert;
                             alertHTML += '</div>';
                         };
                         
                        //  $('#alertBox').removeClass('alertBoxInactive');
                        //  $('#alertBox').addClass('alertBoxActive');
                        this.formFields.isAlertBoxInactive=false;
                         hasEquipmentAlert = true;
                     }
                     if ( nickNameAlert.machineNickName && nickNameAlert.machineNickName[0].IsNickNameEnabledMsg && nickNameAlert.machineNickName[0].IsNickNameEnabledMsg.length) {
                         alertHTML += '<div>';
                         alertHTML += nickNameAlert.machineNickName[0].IsNickNameEnabledMsg;
                         alertHTML += '</div>';
     
                        //  $('#alertBox').removeClass('alertBoxInactive');
                        //  $('#alertBox').addClass('alertBoxActive');
                        this.formFields.isAlertBoxInactive=false;
                         hasNickNameAlert = true;
                     }
                     if (ipAddressAlert.machineIPAddress && ipAddressAlert.machineIPAddress[0].IsMachineIPEnabledMsg && ipAddressAlert.machineIPAddress[0].IsMachineIPEnabledMsg.length) {
                         alertHTML += '<div>';
                         alertHTML += ipAddressAlert.machineIPAddress[0].IsMachineIPEnabledMsg;
                         alertHTML += '</div>';
                        //  $('#alertBox').removeClass('alertBoxInactive');
                        //  $('#alertBox').addClass('alertBoxActive');
                        this.formFields.isAlertBoxInactive=false;
                         hasNickNameAlert = true;
                     }
                     if (!hasEquipmentAlert && !hasNickNameAlert && !hasIpAddressAlert) {
                         alertHTML += 'No alerts found for the selected equipment.';
                        //  $('#alertBox').removeClass('alertBoxActive');
                        //  $('#alertBox').addClass('alertBoxInactive');
                        this.formFields.isAlertBoxInactive=true;
                     }
                    //  $('#alertBox').html(alertHTML);
                    this.formFields.alertBox=alertHTML;
                 }
                catch(err){
                    //setTimeout('getEquipmentAlerts()',500);
                    console.log(err);
                }
              },
              err => console.error(err)
            );
        }
    }
    public voidTicket(){
        var UPDATETICKET = {
            "UPDATETICKET": {
                "ticketId": this.formFields.TicketId,
                "UserID": this.userid,
                 "TICKETFIELDS": {
                     "ticketStatusId" :3
                 }
            }
        };
              
        var srResult = null;
        
        //ADD THE VOID NOTE
        var ADDTICKETNOTE = {
            ticketId:this.formFields.TicketId,
            note:this.formFields.voidReason
        }

        var REMOVETICKETFROMSERVICEREQUEST={
            ticketId:this.formFields.TicketId,
            userId:this.userid
        }
        this._ticketService.addTicketNote(JSON.stringify({ADDTICKETNOTE})).subscribe((Result: any) => {
            if(Result!=null){
               //VOID THE TICKET 
           
            } else {
                alert('Error adding void note.');
            }
            }, 
            (respose: Response) => {
              // handle error here
            }
          ); 	
          this._ticketService.updateTicket(JSON.stringify(UPDATETICKET)).subscribe((Result: any) => {
            if(Result!=null){
               
                // location.href = dashBoardURL;
            } else {
                alert('error removing the voided ticket from service requests');
            }
            }, 
            (respose: Response) => {
              // handle error here
            }
          ); 
          this._servicerequestService.removeTicketFromServiceRequest(JSON.stringify({REMOVETICKETFROMSERVICEREQUEST})).subscribe((Result: any) => {
            if(Result!=null)
            {
                //alert('Ticket Successfully Voided');	
                this._messageService.confirmThis("Success:Ticket Successfully Voided", ()=>
                { 
                    this.router.navigate(['/dashboard']);
                });
            } 
            else 
            {
                alert('error removing the voided ticket from service requests');
            }
            }, 
            (respose: Response) => {
              // handle error here
            }
          ); 
            
    }
}